import { render } from "./voucher.vue?vue&type=template&id=5a38507b&scoped=true"
import script from "./voucher.vue?vue&type=script&lang=js"
export * from "./voucher.vue?vue&type=script&lang=js"

import "./voucher.vue?vue&type=style&index=0&id=5a38507b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a38507b"]])

export default __exports__